import { ApiCmnHeadersGetCall } from "../JS/Connector";
import { log } from "../JS/Logger";

async function downloadSampleCSV(importType, fileName) {
    await ApiCmnHeadersGetCall(`/csv/import-template?fileType=${importType}`, true, true)
        .then(response => JSON.parse(response))
        .then(responseRS => {
            try {
                const csvContent = [];

                if (responseRS?.headers?.length > 0 && responseRS?.data?.length > 0) {
                    const dataKeys = Object.keys(responseRS.data[0]);

                    const normalizeStr = (str) => str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

                    const headerToKeyMap = {};
                    responseRS.headers.forEach((header) => {
                        const normalizedHeader = normalizeStr(header);
                        const matchedKey = dataKeys.find(
                            (key) => normalizeStr(key) === normalizedHeader
                        );
                        headerToKeyMap[header] = matchedKey || null;
                    });

                    csvContent.push(responseRS.headers);

                    responseRS.data.forEach((rowObj) => {
                        const rowValues = responseRS.headers.map((header) => {
                            const key = headerToKeyMap[header];
                            const value = key ? rowObj[key] ?? '' : '';
                            return `"${String(value).replace(/"/g, '""')}"`;
                        });
                        csvContent.push(rowValues);
                    });

                } else {
                    log.error('No data available for download.');
                    return;
                }

                const csvString = csvContent.map((row) => row.join(',')).join('\n');
                const blob = new Blob([csvString], { type: 'text/csv' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                log.error('Error processing CSV data:', error);
            }
        })
        .catch(error => {
            log.error('Error downloading sample CSV:', error);
        });
}

export { downloadSampleCSV };